<template>
  <v-container v-if="fullLoaded" fluid>
    <v-alert
      :value="msg"
      type="error"
      dismissible
      transition="scale-transition"
      v-for="msg in message"
      :key="msg"
      >{{ msg }}</v-alert
    >
    
    <v-row
      justify-space-around
      row
      fill-height
    >
      <v-col cols="3">
        <v-card :loading="loading" :disabled="loading">
          <v-toolbar tabs flat color="secondary" dark>
            <v-icon left>mdi-chat</v-icon>
            <v-toolbar-title>Comments</v-toolbar-title>
          </v-toolbar>
          <order-comment :orderId="order.id"></order-comment>
        </v-card>
      </v-col>
      <v-col cols="6" mr-4>
        <v-row>
          <v-col>
            
            <OrderDetail :order="order">
              <!--v-btn text :to="'/build/build/' + order.id + '/package-list'">
                <v-icon left>mdi-printer</v-icon>Package List
              </v-btn -->
              <InvoiceDetail v-if="handling.invoice_id" :invoiceId="handling.invoice_id">
                <template #activator="{on, attr}">
                  <v-btn text v-on="on" v-bind="attr">View Invoice</v-btn>
                </template>
              </InvoiceDetail>
            </OrderDetail>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="mb-4" :loading="loading" :disabled="loading">
              <v-toolbar tabs flat color="secondary" dark>
                <v-icon left>mdi-clipboard-text</v-icon>
                <v-toolbar-title>Product lists in this handling</v-toolbar-title>
                <v-spacer />
                <v-btn
                  v-if="canMarkAllProductAsBuilt"
                  color="accent"
                  @click="doMarkAllProductsAsBuilt"
                >
                  Mark all as built
                </v-btn>
              </v-toolbar>
              <handling-items :handling="handling" @update="update()"/>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3" md4>
        <BuildInfo :order="order" :build="build" :handling="handling" />

        <v-card v-if="handling.status_id != 'shipped'" :loading="loading" :disabled="loading">
          <v-card-title>Actions</v-card-title>
          <v-card-text>
            <v-row v-if="handling.status_id == 'on cart'">
              <v-col>
                <v-btn
                  color="primary"
                  @click="start()"
                  >Start building</v-btn
                >
              </v-col>
            </v-row>
            <v-row v-if="handling.status_id == 'building'">
              <v-col>
                <v-btn
                  color="orange ligthen-1"
                  @click="wait()"
                  >Put on cart to waiting</v-btn
                >
              </v-col>
            </v-row>
            <v-row v-if="handling.status_id == 'building'">
              <v-col>
                <ConfirmShipping
                  :handling="handling"
                  @input="update"
                />
              </v-col>
            </v-row>
            <v-row v-if="handling.status_id == 'shipping'">
              <v-col>
                <MarkAsSent :handling="handling" :order="order" @refresh="init"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <OnCartBuildView v-if="handling.status_id=='on cart'" v-model="order" />
    <BuildingView v-if="handling.status_id=='building'" v-model="order" :build="build" :handling="handling" @update="update" />
    <ShippingBuildView v-if="handling.status_id=='shipping'" v-model="order" />
    <ShippedBuildView v-if="handling.status_id=='shipped'" v-model="order" :handling="handling" />
    <ConfirmBox ref="confirm" />
  </v-container>
  <page-loading v-else />
</template>

<script>
import OrderDetail from '../../../components/build/OrderDetail.vue';
import OrderComment from "@components/orders/OrderComment.vue";

import BuildInfo from '../../../components/build/Info.vue';

import ShippingBuildView from '../../../components/handling/ShippingBuildView.vue';
import OnCartBuildView from '../../../components/handling/OnCartBuildView.vue';
import BuildingView from '../../../components/handling/BuildingView.vue';
import ShippedBuildView from '../../../components/handling/ShippedBuildView.vue';

import MarkAsSent from '../../../components/handling/dialog/MarkAsSent.vue';

import { mapActions, mapGetters } from 'vuex';
import HandlingItems from '../../../components/handling/HandlingItems.vue';
import ConfirmBox from '../../../components/ui/ConfirmBox.vue';
import ConfirmShipping from '../../../components/handling/dialog/ConfirmShipping.vue';
import InvoiceDetail from '../../../components/invoices/InvoiceDetail.vue';
import PageLoading from '../../../components/PageLoading.vue';

export default {
  components: {
    OrderComment,
    OnCartBuildView,
    BuildingView,
    ShippingBuildView,
    BuildInfo,
    OrderDetail,
    MarkAsSent,
    ShippedBuildView,
    HandlingItems,
    ConfirmBox,
    ConfirmShipping,
    InvoiceDetail,
    PageLoading
},
  data: function() {
    return {
      items: [],
      tabs: null,
      handling: null,
      order:null,
      build:null,
      handlingId: null,
      message: null,
      tabHandlingDetail: null,
      valid: null,
    };
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.handlingId = this.$route.params.id;
      this.init()
    } else {
      this.$route.push("/prescription");
    }
  },
  computed: {
    ...mapGetters('handling', { handlingLoading: 'loading' }),
    ...mapGetters('build', { buildLoading: 'loading' }),
    ...mapGetters('orders', { orderLoading: 'loading' }),
    loading () {
      return this.handlingLoading || this.buildLoading || this.orderLoading
    },
    fullLoaded: function() {
      return this.handling && this.order && this.build;
    },
    canMarkAsCompleted: function(){
      if(this.order.prescription){
        if(this.order.prescription.isMarkableToSent){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    canMarkAllProductAsBuilt() {
      return !this.handling.havePrescription && this.handling.status_id == 'building'
    },
    allProductsBuilt () {
      if(this.order.prescription) {
        return this.handling.items.find(item => item.quantity > item.built) ? false : true        
      }
      return true;
    }
    
  },
  methods: {
    ...mapActions("build", {fetchBuild:'get'}),
    ...mapActions("handling", {fetchHandling:'get', changeStatus:"changeStatus", markAllProductsAsBuilt:"markAllProductsAsBuilt"}),
    ...mapActions("orders", {fetchOrder:'get'}),
    init(){
      this.getHandling(this.handlingId);
    },
    getHandling(id) {
      this.fetchHandling(id)
        .then(({handling}) => {
          this.handling = handling
          this.getBuild(this.handling.build_id);
        });
    },
    getBuild(id) {
      this.fetchBuild(id)
        .then(({build}) => {
          this.build = build
          this.getOrder(this.build.order_id);
        });
    },
    getOrder(id){
      this.fetchOrder({id, expand:'prescription'})
        .then((data) => {
          this.order = data;
        });
    },
    update() {
      this.init()
    },
    error(payload) {
      this.message = [];
      for (const field in payload) {
        if ({}.propertyIsEnumerable.call(payload, field)) {
          const msg = payload[field];
          this.message.push(msg[0]);
        }
      }
    },
    start() {
      this.changeStatus({id:this.handling.id, status_id:'building'})
      .then(({model}) => {
        this.handling = model;
      })
    },
    wait() {
      this.changeStatus({id:this.handling.id, status_id:'on cart'})
      .then(({model}) => {
        this.handling = model;
      })
    },
    async shipping() {
      if(this.allProductsBuilt || await this.$refs.confirm.open("Confirm", "Some products are not built, if you go to shipping these products will be returned to Pending Box")){
        this.changeStatus({id:this.handling.id, status_id:'shipping'})
          .then(({model}) => {
            this.handling = model;
          })
      }
    },
    async doMarkAllProductsAsBuilt() {
      if(await this.$refs.confirm.open("Are you sure ?", "Are you sure to mark all products as built ?")){
        this.markAllProductsAsBuilt(this.handling.id)
          .then(({handling}) => {
            this.handling = handling;
          })
      }
    }

  },
};
</script>

<style lang="less" scoped></style>
